<template>
  <div>
    <div class="root-landing userpage-bg-fill userpage-bg-fill--vox bg-vox-populi bg-animation">
      <div class="root-landing-inner">
        <div class="root-landing-center">
          <v-img
            src="/images/logo_login.png"
            max-width="360"
            width="100%"
            height="138"
            contain
            class="mx-auto"
          />
        </div>
        <div class="root-landing-footer text-center text-white opacity-8">
          Copyright &copy; Onikom Ltd
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RootLanding",
};
</script>

<style scoped>
.root-landing-inner {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 2rem 1rem;
}

.root-landing-center {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.root-landing-footer {
  flex-shrink: 0;
  padding-top: 1rem;
}
</style>
